import { Inbox } from 'lucide-react'

import { Icon } from '../Icon'

export const EmptyState = ({ action, children, icon = <Icon as={Inbox} size={32} />, title, ...props }) => (
  <div className="ds-empty-state tw:flex tw:min-h-[220px] tw:flex-col tw:items-center tw:justify-center tw:px-5 tw:py-8 tw:text-center" {...props}>
    {icon && <div className="tw:mb-4 tw:text-foreground-subtle">{icon}</div>}
    <div className="ds-heading-4">{title}</div>
    {children && <div className="ds-helper tw:mt-2 tw:max-w-[460px]">{children}</div>}
    {action && <div className="tw:mt-4">{action}</div>}
  </div>
)
